import { configureStore } from '@reduxjs/toolkit';
import filtersReducer from './filterSlice';
import columnPreferencesReducer from './slices/columnPreferencesSlice'

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    columnPreferences: columnPreferencesReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Log du store au démarrage (dev only)
if (process.env.NODE_ENV === 'development') {
  console.log('🏪 Redux store initialized:', store.getState())
}
